function notify(text) {

	text = (text == '' || text == undefined) ? 'Notificación!' : text;
	
	let notify = null;
	const identifier = Math.floor(Math.random() * (99999 - 1)) + 1;
	const page_body = $('body');

	const getSelector = function (identifier) {
		return $(`#notify-${identifier}`);
	}

	const getTimeReading = function (text) {

		text = text.replace(/ /g, '');
		let length = text.length
		
		return length * 100 + 1000;
	}

	let html = `
		<div id="notify-${identifier}" class="notify">
			<div class="notify__dialog">
				<p class="notify__text">${text}</p>
			</div>
		</div>
	`;

	$('.notify').hide();
	page_body.append(html);

	notify = getSelector(identifier);

	setTimeout(() => {
		notify.addClass('is--active');
	}, 100);

	setTimeout(() => {
		notify.removeClass('is--active');
	}, getTimeReading(text));

}